import { gql } from "@apollo/client";


export const GET_SUGERENCIAS_MONITOREO = gql`
query profesionalMonitoreoSugerencia($idDelegacion: Int!, $idEstado: Int!, $fechaDesde: CustomDateTime!, $fechaHasta: CustomDateTime!){
    profesionalMonitoreoSugerencia(
        filter: {
            idDelegacion: $idDelegacion
            idEstado: $idEstado
            fechaDesde: $fechaDesde
            fechaHasta: $fechaHasta
        }
    ){
        idProfesionalMonitoreoSugerencia
        idProfesionalMonitoreo
        idDelegacion
        delegacion
        idProfesional
        profesional
        claseActual
        claseSugerida
        resultadoUltimoMonitoreo
        fechaSolicitud
        idEstado
        estado
        usuarioSolicitante
        usuarioGestion
        fechaResolucion
        observacionUsuarioGestion
        observacionUsuarioSolicitante
    }
}
`;

const adaptSugerenciaRow = (sugerencia) => {
  return {
    idSugerenciaMonitoreo: sugerencia?.idProfesionalMonitoreoSugerencia,
    idProfesionalMonitoreo: sugerencia?.idProfesionalMonitoreo,
    observacionUsuarioGestion: sugerencia?.observacionUsuarioGestion,
    observacionUsuarioSolicitante: sugerencia?.observacionUsuarioSolicitante,
    idProfesional: sugerencia?.idProfesional,
    idDelegacionResponsable: sugerencia?.idDelegacion,
    nombreProfesional: sugerencia?.profesional,
    claseActual: sugerencia?.claseActual,
    claseSugerida: sugerencia?.claseSugerida,
    resultadoUltimoMonitoreo: sugerencia?.resultadoUltimoMonitoreo,
    fechaSolicitud: sugerencia?.fechaSolicitud,
    solicitud: sugerencia?.solicitud,
    idEstado: sugerencia?.idEstado,
    solicitante: sugerencia?.usuarioSolicitante,
    fechaResolucion: sugerencia?.fechaResolucion,
    autorizador: sugerencia?.usuarioGestion
  };
};

export const adaptSugerenciasArray = (sugerencias) => {
  return (
    structuredClone(
      sugerencias?.profesionalMonitoreoSugerencia
    )?.map((sugerencia) => adaptSugerenciaRow(sugerencia)) || []);

};